import React from 'react';
import './CreatorComponent.css';
import '../../App.css'
import CreatorContentComponent from "./creator_item/CreatorContentComponent";
import aboutUsItems from "../../data/about_us";
import {Box, Flex, Grid, GridItem, Spacer} from "@chakra-ui/react";
import {Animated} from "react-animated-css";
import {useTranslation} from "react-i18next";

const CreatorComponent = () => {
    const [t, i18n] = useTranslation('common');
    return (
        <Flex className="tab-creator-component">
            <Spacer/>
            <Box className="body-description-small">
                {t("Indie was created by independent filmmakers")}
                <span
                    className="body-description-yellow-small">{t(" to improve the casting process ")}
                 </span>
                {t(" for ")}
                <span className="body-description-orange-small">{t(" producers and actors alike.")}
                 </span>
            </Box>

            <Spacer/>

            <Animated animationIn="fadeIn"
                      animationOut="fadeOut"
                      isVisible={true}
                      animationInDuration={4000}>
                <Grid gap="20px" className="creator-grid">
                    {aboutUsItems?.map((item) => {
                        return (
                            <GridItem>
                                <CreatorContentComponent itemData={item}/>
                            </GridItem>

                        )
                    })}

                </Grid>
            </Animated>
            <Spacer/>
        </Flex>
    )

}
export default CreatorComponent